var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConditionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0025 9.99919V7.82629C18.0025 7.29607 17.7914 6.78686 17.4163 6.4117L14.5871 3.58252C14.212 3.20736 13.7027 2.99628 13.1725 2.99628H5.99754C4.89208 2.99628 3.9967 3.89165 3.9967 4.99711V19.0029C3.9967 20.1084 4.89208 21.0038 5.99754 21.0038H9.9992",
    stroke: "#003541",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0026 7.99836H14.0009C13.4487 7.99836 13.0005 7.55017 13.0005 6.99794V2.99628",
    stroke: "#003541",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5019 22.0042C14.0158 22.0042 12 19.9884 12 17.5023C12 15.0163 14.0158 13.0004 16.5019 13.0004C18.9889 13.0004 21.0037 15.0163 21.0037 17.5023C21.0037 19.9884 18.9889 22.0042 16.5019 22.0042",
    stroke: "#003541",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5029 17.3353V15.6836",
    stroke: "#003541",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5019 19.158C16.4569 19.158 16.4199 19.195 16.4209 19.24C16.4209 19.2851 16.4579 19.3221 16.5029 19.3221C16.5479 19.3221 16.5839 19.2851 16.5839 19.24C16.5839 19.195 16.5479 19.158 16.5019 19.158",
    stroke: "#003541",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionsIcon);
export default __webpack_public_path__ + "static/media/conditions-icon.2300609967101567bbda761e57506cc8.svg";
export { ForwardRef as ReactComponent };